import { Action } from 'redux';
import { actionTypes as t } from '../actions';

type IsNotesVisibleAction = {
  type: string;
  payload: {
    isVisible: boolean;
  };
};

export const isNotesVisibleReducer = (state = false, action: Action) => {
  switch (action.type) {
    case t.UPDATE_NOTES_VISIBILITY: {
      return (action as IsNotesVisibleAction).payload.isVisible;
    }
    case t.TOGGLE_NOTES_VISIBILITY: {
      return !state;
    }
    case t.SHOW_NOTES: {
      return true;
    }
    case t.HIDE_NOTES: {
      return false;
    }
    default:
      return state;
  }
};
